{
  "version": 1,
  "asset_id": "9515ecb5-2168-4c52-91cc-fd5fd2a6a0d3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/9515ecb5-2168-4c52-91cc-fd5fd2a6a0d3/sleeve-ugi-normal-1145.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/9515ecb5-2168-4c52-91cc-fd5fd2a6a0d3/sleeve-ugi-normal-1145.webp",
  "original_filename": "sleeve-ugi-normal-1145.webp",
  "size": 106062,
  "content_type": "image/webp",
  "created_at": "2026-09-28T01:31:15Z"
}
